import React, { useState } from "react";
import ReceiptComponent from "../../components/Accounts/ReceiptComponent";
import { CustomModal } from "../../components/CustomModal";
import { buttonTexts, receiptDetails, returnReceiptTitle } from "./data";
import { Hrule } from "../../pages/AddUserPage/AddUser";
import Button from "../../components/Button/Button";
import { styled } from "styled-components";
import { colors } from "../../theme/color";
import { useDispatch, useSelector } from "react-redux";
import { RootState } from "../../store/rootReducer";
import { setPaymentReceiptModalOpen } from "../../store/accountsModal";
import { formatDateTime } from "../../utils/formatTimeAndDate";
import { formatAmount } from "../../utils/formatAmount";
import { useNavigate } from "react-router-dom";
import { TransferDetails } from "../TransactionTable";

const PaymentReceipt = () => {
  const navigate = useNavigate();
  const { paymentReceiptModalOpen, paymentReceiptObj } = useSelector(
    (state: RootState) => state.accountsModal
  );

  const id = useSelector((state: RootState) => state.user?.user.id);
  const dispatch = useDispatch();

  const handleClose = () => {
    dispatch(
      setPaymentReceiptModalOpen({
        open: false,
        receiptObj: null,
        modalType: null,
      })
    );
  };

  const [isCopied, setIsCopied] = useState(false);

  const handleCopyTransactionId = () => {
    if (paymentReceiptObj && paymentReceiptObj.id) {
      navigator.clipboard.writeText(paymentReceiptObj.id);
      setIsCopied(true);
      setTimeout(() => {
        setIsCopied(false);
      }, 3000);
    }
  };

  const handleDownloadReceipt = () => {
    window.print();
  };
  const navigateToPaymentPage = () => {
    handleClose();
    navigate("/dashboard/accounts/payment-details");
  };

  return (
    <div>
      <CustomModal
        open={paymentReceiptModalOpen}
        onClose={handleClose}
        header={{
          title: "Transaction Details",
          subtitle: "",
        }}
      >
        <React.Fragment>
          {returnReceiptTitle({
            isFipayTag: paymentReceiptObj?.transferType === "Fipay Tag",
            isPayAnyone: paymentReceiptObj?.transferType === "pay_anyone",
            isBankTransfer: paymentReceiptObj?.transferType === "wire_transfer",
            isWireTransfer: paymentReceiptObj?.transferType === "Bank",
          }).map((receipt) => (
            <React.Fragment key={receipt.title}>
              <ReceiptComponent
                title={receipt.title}
                description={
                  <DescriptionStyle
                    $hasStatus={receipt.title === "STATUS"}
                    $successful={
                      receipt.title === "STATUS" &&
                      paymentReceiptObj?.transferStatus === "complete"
                    }
                    $pending={
                      paymentReceiptObj?.transferStatus === "pendingApproval"
                    }
                  >
                    {receipt.title === "DATE" &&
                    paymentReceiptObj?.createdAt ? (
                      <span
                        style={{
                          display: "flex",
                          gap: "0.5rem",
                          whiteSpace: "nowrap",
                        }}
                      >
                        <strong>
                          {formatDateTime(paymentReceiptObj.createdAt).date}
                        </strong>
                        <span style={{ color: "#868686" }}>
                          {formatDateTime(paymentReceiptObj.createdAt).time}
                        </span>
                      </span>
                    ) : receipt.title === "AMOUNT SENT" ||
                      receipt.title === "TRANSACTION FEE" ? (
                      <span>
                        {formatAmount(paymentReceiptObj?.[receipt.key])}
                      </span>
                    ) : receipt.title === "STATUS" ? (
                      <span>
                        {paymentReceiptObj?.transferStatus === "complete"
                          ? "Successful"
                          : paymentReceiptObj?.transferStatus ===
                              "pendingApproval"
                            ? "Pending"
                            : "Failed"}
                      </span>
                    ) : (
                      <span>{paymentReceiptObj?.[receipt.key]}</span>
                    )}
                    {receipt.hasIcon && (
                      <img
                        src="/assets/icons/copy.svg"
                        alt="copy icon"
                        onClick={handleCopyTransactionId}
                        style={{ cursor: "pointer" }}
                      />
                    )}
                    {isCopied && receipt.hasIcon && (
                      <span
                        style={{
                          color: "green",
                        }}
                      >
                        Copied!
                      </span>
                    )}
                  </DescriptionStyle>
                }
              />
              {receipt.hasBorder && <Hrule style={{ margin: "1rem 0" }} />}
            </React.Fragment>
          ))}
        </React.Fragment>

        <ReceiptButton>
          {buttonTexts.map((text, index) => (
            <Button
              id={""}
              type="button"
              onClick={
                index === 0 ? handleDownloadReceipt : navigateToPaymentPage
              }
              padding={"10px 0"}
              width="100%"
              title={text}
              border="10px"
              green={index === 0}
              className={index === 1 ? "customButton" : ""}
            />
          ))}
        </ReceiptButton>
        <Support>
          Need help? <span>Contact Support</span>
        </Support>
      </CustomModal>
    </div>
  );
};

export default PaymentReceipt;

export const ReceiptButton = styled.div`
  margin-top: 2rem;
  display: flex;
  flex-direction: column;
  gap: 1rem;
  .customButton {
    border: 1px solid #afafaf;
    color: #afafaf;
  }
  button :hover {
    background-color: inherit;
  }

  @media print {
    display: none;
  }
`;
export const Support = styled.p`
  color: #868686;
  text-align: center;
  span {
    color: ${colors.GREEN} !important;
  }
  @media print {
    display: none;
  }
`;
export const DescriptionStyle = styled.div<{
  $successful?: boolean;
  $pending?: boolean;
  $hasStatus?: boolean;
}>`
  border: ${({ $successful, $pending, $hasStatus }) =>
    $hasStatus
      ? `0.8px solid ${$successful ? "#C3E6C0" : $pending ? "#F6D8AA" : "#FED8D8"}`
      : ""};
  border-radius: ${({ $hasStatus }) => ($hasStatus ? "16px" : "")};
  padding: ${({ $hasStatus }) => ($hasStatus ? "4px 6px" : "")};
  color: ${({ $successful, $pending, $hasStatus }) =>
    $hasStatus
      ? `${$successful ? "#4BB543" : $pending ? "#E89D2B" : "#FA3E3E"}`
      : ""};
  background-color: ${({ $successful, $pending, $hasStatus }) =>
    $hasStatus
      ? `${$successful ? "#C3E6C0" : $pending ? "#F6D8AA" : "#FED8D8"}`
      : ""};
`;
